export default __webpack_public_path__ + "static/media/github-logo-face.3a1569b2.svg";